// extracted by mini-css-extract-plugin
export default {"root":"Image_root__EnFW4","hasOnClick":"Image_hasOnClick__MKhar","image":"Image_image__Jo8M7","cover":"Image_cover__PsYh6","loading":"Image_loading__NRVO7"};